import { Card, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Spacer } from "@internal/plugin-utilities";
import { makeStyles } from "@material-ui/styles";
import { SectionHeader } from "../TeamBreakdown/SectionHeader/SectionHeader";
import { Progress } from "@backstage/core-components";
import { InformationTooltip } from "../InformationTooltip";

const useStyles = makeStyles(() => ({
  freeform: {
    height: "100%",
    padding: "20px",
  },
  freeformSection: {
    fontSize: "1.2em",
    "& table": {
      border: "1px solid white",
      borderCollapse: "collapse",
    },
    "& tr": {
      border: "1px solid white",
      borderCollapse: "collapse",
    },
    "& td": {
      padding: "5px",
      border: "1px solid white",
      borderCollapse: "collapse",
    },
    "& a": {
      color: "#5dadec",
    },
  },
}));

interface Props {
  data: any;
  loading: boolean;
}

export const FreeformSection: React.FC<Props> = ({
  data,
  loading,
}): JSX.Element => {
  const classes = useStyles();

  const tooltip = (
    <>
      <Typography variant="h5">Noteworthy</Typography>
      <div>
        The noteworthy section is a freeform field to add any other important
        items you'd like to bring up in the OpsReview. This can be editted from
        the (<code>/ops-review/edit</code>) page.
      </div>
    </>
  );

  const header = (
    <div style={{ textAlign: "center" }}>
      <SectionHeader title="🎶 Noteworthy 🎸" />
      <InformationTooltip title={tooltip} />
      <Spacer variant="normal" />
    </div>
  );

  if (loading) {
    return <Progress />;
  }

  if (!data || (data && data.length === 0)) {
    return (
      <div>
        {header}
        <Typography align="center" variant="h6">
          No other topics to display
        </Typography>
      </div>
    );
  }

  return (
    <div>
      {header}
      {data && (
        <Grid container className={classes.freeformSection}>
          {data.map((ff: any, idx: number) => {
            return (
              <Grid item sm={12} lg={4} key={`freeform-${idx}`}>
                <Card
                  className={classes.freeform}
                  dangerouslySetInnerHTML={{ __html: ff }}
                />
              </Grid>
            );
          })}
        </Grid>
      )}
    </div>
  );
};
